/**
 * @generated SignedSource<<8b6d29a08236f0066927e4d602054047>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelActionsDelegateButtonFragment$data = {
  readonly address: {
    readonly resolvedName: {
      readonly address: string;
    };
  };
  readonly " $fragmentType": "VoterPanelActionsDelegateButtonFragment";
};
export type VoterPanelActionsDelegateButtonFragment$key = {
  readonly " $data"?: VoterPanelActionsDelegateButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelActionsDelegateButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelActionsDelegateButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResolvedName",
          "kind": "LinkedField",
          "name": "resolvedName",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "ab0a53f94e734ae21c0f141bfbe3c956";

export default node;
